import React from 'react';
import { motion } from 'framer-motion';
export function ShowcaseSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-start md:justify-center px-4 md:px-8 bg-[#11166b] overflow-y-auto md:overflow-hidden py-16 md:py-0" data-id="element-139">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-8 md:mb-12 mt-4 md:mt-0" data-id="element-140">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-141">
          Built for Scale
        </h2>
        <p className="text-base md:text-lg text-slate-300" data-id="element-142">
          A unified experience for drivers and operators.
        </p>
      </motion.div>

      <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center max-w-7xl w-full pb-24 md:pb-0" data-id="element-143">
        {/* Mobile App Showcase */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 flex flex-col items-center w-full" data-id="element-144">
          <div className="relative rounded-[2rem] md:rounded-[2.5rem] overflow-hidden border-4 md:border-8 border-[#1a2080] shadow-2xl bg-[#0d1155] max-w-[240px] md:max-w-[300px]" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/6rYyCYqHGyAUiQz8hAzmJQ/app.png" alt="Mobile App Interface" className="w-full h-auto object-cover" data-id="element-146" />
          </div>
          <p className="mt-4 md:mt-6 text-slate-300 font-medium text-center text-sm md:text-base" data-id="element-147">
            White-label driver app with real-time insights
          </p>
        </motion.div>

        {/* Portal Showcase */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex-[1.5] flex flex-col items-center w-full" data-id="element-148">
          <div className="relative rounded-xl overflow-hidden border-4 border-[#1a2080] shadow-2xl bg-[#0d1155] w-full" data-id="element-149">
            <div className="h-6 bg-[#1a2080] flex items-center px-4 gap-2" data-id="element-150">
              <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-151" />
              <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-152" />
              <div className="w-2 h-2 rounded-full bg-[#00d8a8]" data-id="element-153" />
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/bCG7336NMj7UfBodDjkiQa/portal.png" alt="Management Portal Interface" className="w-full h-auto object-cover" data-id="element-154" />
          </div>
          <p className="mt-4 md:mt-6 text-slate-300 font-medium text-center text-sm md:text-base" data-id="element-155">
            Centralized management for all installations
          </p>
        </motion.div>
      </div>
    </div>;
}